import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/sellers/:id',
  title: 'title.show',
  endpoint: '/app/person',
  breadcrumbs: [],
}
